import axios from 'axios';

export async function getPublicLeagueData(league_pk) {
  try {
    const res = await axios({
      method: 'GET',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/public-leagues/${league_pk}/`,
    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

